module.exports = __webpack_public_path__ + "assets/cacf64e36304b2866c5c32d576b0468c.png";